export const rentalRoutes = {
	rentals: (query?: string) => `/rentals/${query ? `?${query}` : ''}`,
	rental: (id: string) => `/rentals/${id}/`,
	rentalHistory: (id: string) => `/rentals/${id}/history/`,
	rentalsSyncToRegla: '/rentals/sync_to_regla/'
} as const
